import { useEffect } from 'react';
import confetti from 'canvas-confetti';

interface ConfettiCanvasProps {
  trigger: boolean;
}

export const ConfettiCanvas: React.FC<ConfettiCanvasProps> = ({ trigger }) => {
  useEffect(() => {
    if (!trigger) return;

    const duration = 2000;
    const animationEnd = Date.now() + duration;

    const colors = ['#5E81AC', '#88C0D0', '#81A1C1', '#A3BE8C'];

    const runConfetti = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors: colors,
      });

      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors: colors,
      });

      if (Date.now() < animationEnd) {
        requestAnimationFrame(runConfetti);
      }
    };

    runConfetti();
  }, [trigger]);

  return null;
};
